import styled from "styled-components";
import { DESKTOP_SM_BP } from "@website-builder/utilities-index";

export const BannerWrapper = styled.div`
	margin: 0;
	.banner-image {
		width: 100%;
	}
`;
